module.exports = __webpack_public_path__ + "96c997b61b92623910ab361d77061bcd.svg";